import { useEffect } from 'react';
import { useBlocker } from 'react-router';

export const useWebviewLock = (enabled = true) => {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      enabled && currentLocation.pathname !== nextLocation.pathname
  );

  useEffect(() => {
    if (blocker.state === 'blocked') {
      blocker.reset();
    }
  }, [blocker]);
};
